const path1 =
  'M9.687 3.077a8.472 8.472 0 0 0-.67 2.747c-4.19 2.762-6.958 7.503-6.958 12.896 0 4.264 1.729 8.124 ' +
  '4.522 10.918 2.795 2.795 6.656-.624 10.919-.624 1.063 0 2.1.212 3.103.488-.003.095-.014.188-.014.284 0 2.173.8' +
  '76 4.143 2.289 5.584-1.695.546-3.5.85-5.378.85-9.665 0-17.5-7.835-17.5-17.5C0 11.866 3.949 5.949 9.687 3.077Zm' +
  '18.879 20.275c.064 0 .125.007.189.01a6.394 6.394 0 0 1 3.136.923c.627.38 1.187.857 1.65 1.42a6.433 6.433 0 0 1' +
  '-9.055 9.055 6.419 6.419 0 0 1-2.345-4.797c-.002-.06-.009-.117-.009-.177 0-1.536.54-2.945 1.438-4.05a6.42 6.42' +
  ' 0 0 1 4.996-2.384Zm-1.642 3.7a.771.771 0 1 0-1.092 1.091l1.643 1.643-.852.851-.791.792a.77.77 0 0 0 .545 1.31' +
  '8.77.77 0 0 0 .547-.227l1.642-1.643.736.737.907.906a.769.769 0 0 0 1.092 0 .77.77 0 0 0 0-1.09l-1.643-1.644 1.' +
  '643-1.643a.771.771 0 0 0 0-1.092.76.76 0 0 0-.694-.197.748.748 0 0 0-.398.197l-1.643 1.643ZM13.836 14.475a8.74' +
  '5 8.745 0 0 0 6.99.147l.339-.147h.839a6.756 6.756 0 0 1 6.75 6.518l.005.237v.587c-.064-.002-.128-.01-.193-.01-' +
  '2.822 0-5.3 1.477-6.718 3.696l-.143.232H8.654a2.414 2.414 0 0 1-2.408-2.254l-.005-.159v-2.092a6.757 6.757 0 0 ' +
  '1 6.519-6.75l.237-.005h.839Zm11.476-11.4C31.052 5.95 35 11.867 35 18.72a17.48 17.48 0 0 1-.85 5.378 7.982 7.98' +
  '2 0 0 0-1.767-1.315c.353-1.297.558-2.655.558-4.063 0-5.393-2.769-10.134-6.958-12.895a8.447 8.447 0 0 0-.67-2.7' +
  '48ZM17.5 0a6.434 6.434 0 1 1 0 12.868A6.434 6.434 0 0 1 17.5 0Z';

interface DeleteAccountProps {
  colour: string;
}

const DeleteAccount = ({ colour, ...props }: DeleteAccountProps) => (
  <svg width={35} height={37} xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{'Delete Account'}</title>
    <path d={path1} fill={colour} fillRule="evenodd" />
  </svg>
);

export default DeleteAccount;
